var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.498,37.859l.4-.363c.862-.782,1.295-1.93,1.166-3.087l-1.889-16.877,6.913-4.45c1.254-.807,2.195-2.018,2.667-3.433l.364-1.09c.105-.315-.108-.647-.438-.681l-1.143-.12c-1.483-.156-2.975.199-4.229,1.006l-6.914,4.45L11.817,4.506c-.999-.597-2.224-.677-3.293-.217l-.496.214c-.372.16-.463.646-.174.93l8.35,8.216,2.548,4.487-7.809,5.027-5.828-1.554c-.332-.089-.687-.033-.976.153l-1.012.651c-.373.24-.36.789.023,1.011l5.027,2.917c.029.017.04.053.026.084l-.829,1.709c-.122.252.066.543.345.536l1.899-.047c.034,0,.062.024.066.058l.573,5.784c.044.441.538.68.911.44l1.012-.651c.289-.186.487-.486.544-.825l.999-5.949,7.809-5.027,3.029,4.177,4.02,11.003c.139.38.619.498.918.226Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorPlane);
export default __webpack_public_path__ + "static/media/indoor-plane.dd9c1b7356c834a5e54abdd7617b6051.svg";
export { ForwardRef as ReactComponent };